










































































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import BaseSuketTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketTabPage";
import StoreSuketPenanggungjawabBayi from "@/store/modules/SuketPenanggungjawabBayi";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import moment from "moment";
import pdf from "vue-pdf";

@Component({
  components: {
    BaseSuketCard,
    pdf
  }
})
export default class SuketPenanggungjawabBayiTabPage extends BaseSuketTabPage {
  @Prop() declare readonly register: string | number;

  // Diterbitkan dari bangsal Perinatal/Kebidanan mana pun → izinkan seluruh
  // unit. Kunci read-only tetap datang dari edit-window halaman.
  allowedUnit = ["*"];
  suketSvc = new CommonSuket(EnSuketCategory.PenanggungjawabBayi);
  suketStore = StoreSuketPenanggungjawabBayi;

  register_id = this.register;
  pasien_rm = this.pasien.rm;
  unit_id = this.user.unit_id;
  surat_date = moment().format("YYYY-MM-DD");
  creator_user_id = this.user.id;

  penanggungjawab: any = {
    nama: null,
    tempat_lahir: null,
    tanggal_lahir: null,
    jenis_kelamin: null,
    no_identitas: null,
    alamat: null,
    pekerjaan: null,
    no_hp: null,
    hubungan: null
  };
  bayi: any = {
    nama: null,
    tanggal_lahir: null,
    jenis_kelamin: null,
    no_rm: null
  };
  saksi: any = { nama: null };
  tempat_tanggal: any = { kota: "Bantul" };

  saving = false;
  loadedRatio = 0;
  validasi = [v => !!v || "*Kolom ini harus diisi"];

  jenisKelaminOptions = [
    { text: "Laki-laki", value: "L" },
    { text: "Perempuan", value: "P" }
  ];

  get pasien() {
    return storePasien.identitasPasien;
  }

  get user() {
    return userModule.user;
  }

  /**
   * Usia hanya pratinjau — nilai final selalu dihitung ulang server-side
   * (SuketPenanggungjawabBayi::recomputeUsia) agar tidak bisa berkonflik
   * dengan tanggal lahir yang tersimpan.
   */
  get usiaText() {
    const tgl = this.penanggungjawab.tanggal_lahir;
    if (!tgl) return "-";

    const lahir = moment(tgl, "YYYY-MM-DD");
    if (!lahir.isValid() || lahir.isAfter(moment())) return "-";

    return `${moment().diff(lahir, "years")} tahun`;
  }

  get pdfUrl() {
    return this.dataSuket
      ? this.getSuketPdfUrl(
          EnSuketCategory.PenanggungjawabBayi,
          this.dataSuket.id
        )
      : null;
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: {
        penanggungjawab: this.penanggungjawab,
        bayi: this.bayi,
        saksi: this.saksi,
        tempat_tanggal: this.tempat_tanggal
      },
      surat_date: this.surat_date,
      creator_user_id: this.creator_user_id
    };
  }

  mounted() {
    this.hydrate(this.dataSuket);
  }

  hydrate(d: any) {
    this.register_id = d?.register_id || this.register;
    this.pasien_rm = d?.pasien_rm || this.pasien.rm;
    this.unit_id = d?.unit_id || this.user.unit_id;
    this.surat_date = d?.surat_date
      ? moment(d.surat_date).format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD");
    this.creator_user_id = d?.creator_user_id || this.user.id;

    const c = d?.content;
    if (c) {
      // Spread agar key baru tetap ter-default pada record lama.
      this.penanggungjawab = {
        ...this.penanggungjawab,
        ...(c.penanggungjawab || {})
      };
      this.bayi = { ...this.bayi, ...(c.bayi || {}) };
      this.saksi = { ...this.saksi, ...(c.saksi || {}) };
      this.tempat_tanggal = {
        ...this.tempat_tanggal,
        ...(c.tempat_tanggal || {})
      };
    } else if (!this.penanggungjawab.alamat) {
      // Alamat penanggung jawab umumnya sama dengan alamat ibu.
      this.penanggungjawab.alamat = this.pasien.alamat || null;
    }
  }

  @Watch("dataSuket")
  changeDataSuket(val: any) {
    this.hydrate(val);
  }

  save() {
    if (this.saving) return;

    const wajib = [
      [this.penanggungjawab.nama, "Nama penanggung jawab"],
      [this.penanggungjawab.tempat_lahir, "Tempat lahir penanggung jawab"],
      [this.penanggungjawab.tanggal_lahir, "Tanggal lahir penanggung jawab"],
      [this.penanggungjawab.jenis_kelamin, "Jenis kelamin penanggung jawab"],
      [this.penanggungjawab.no_identitas, "Nomor KTP/identitas lain"],
      [this.penanggungjawab.alamat, "Alamat penanggung jawab"],
      [this.penanggungjawab.pekerjaan, "Pekerjaan penanggung jawab"],
      [this.penanggungjawab.no_hp, "Nomor HP"],
      [this.penanggungjawab.hubungan, "Hubungan kekerabatan dengan bayi"],
      [this.bayi.nama, "Nama bayi"],
      [this.bayi.tanggal_lahir, "Tanggal lahir bayi"],
      [this.bayi.jenis_kelamin, "Jenis kelamin bayi"],
      [this.bayi.no_rm, "Nomor rekam medis bayi"],
      [this.saksi.nama, "Nama saksi"]
    ];

    const kosong = wajib.filter(item => !item[0]).map(item => item[1]);
    if (kosong.length) {
      appModule.sendErrorAlert(`Kolom wajib belum diisi: ${kosong.join(", ")}`);
      return;
    }

    if (moment(this.bayi.tanggal_lahir, "YYYY-MM-DD").isAfter(moment(), "day")) {
      appModule.sendErrorAlert("Tanggal lahir bayi tidak boleh di masa depan");
      return;
    }

    if (
      !moment(this.penanggungjawab.tanggal_lahir, "YYYY-MM-DD").isBefore(
        moment(),
        "day"
      )
    ) {
      appModule.sendErrorAlert(
        "Tanggal lahir penanggung jawab harus sebelum hari ini"
      );
      return;
    }

    this.saving = true;
    const action = this.dataSuket
      ? this.suketSvc.update(this.dataSuket.id, this.input)
      : this.suketSvc.create(this.input);

    action
      .then(() => {
        appModule.NoticeDelay("Berhasil Simpan");
        this.close();
        StoreSuketPenanggungjawabBayi.getSuketByRegister(this.register);
      })
      .finally(() => {
        this.saving = false;
      });
  }

  close() {
    this.expandInput = false;
  }
}
